
import { useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { UserContext } from '../../../context/UserContext';
import {
  DesktopContainer,
  LoadingSpinner,
} from '@rabbit/elements/shared-components';
import AddressesContainer from 'apps/olive/src/templates/Account/AddressesContainer';
import { useMyConsumerPersona } from '@rabbit/data/portal';

function AddressesView() {
  const consumerPersona = useMyConsumerPersona();
  const consumerPersonaId = consumerPersona?.personaId;
  const consumerPersonaData = consumerPersona?.data.consumer_private;
  const navigate = useNavigate();
  const location = useLocation() as any;
  const [isLoading, setIsLoading] = useState(false);
  const redirectTo = location?.state?.next as string | undefined;

  if (
    consumerPersonaData === null ||
    !consumerPersonaData ||
    !consumerPersonaId
  )
    return <LoadingSpinner size="md" isFullScreen />;

  return (
    <DesktopContainer
      title="Addresses"
      goBack={() => navigate(-1)}
      loading={isLoading}
    >
      <AddressesContainer
        id={consumerPersonaId}
        data={consumerPersonaData}
        setIsLoading={setIsLoading}
        redirectTo={redirectTo}
      />
    </DesktopContainer>
  );
}

export default AddressesView;
